const initialState = {
    cameras: [],
    camerasFetchedAt: null,
};

export default function pigCounterReducer(state = initialState, action) {
    switch (action.type) {
        case "PIG_COUNTER_SET_CAMERAS": {
            return {
                ...state,
                cameras: action.payload.cameras,
                camerasFetchedAt: action.payload.fetchedAt,
            };
        }
        case "PIG_COUNTER_SET_SELECTED_CAMERA": {
            return {
                ...state,
                cameras: state.cameras.map((camera) => ({
                    ...camera,
                    selected: camera.mac === action.payload.mac,
                })),
            };
        }
        default:
            return state;
    }
}
